import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/AdminUserList.css';
import Toast from './Toast';

function AdminUserList() {
	const [users, setUsers] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [toast, setToast] = useState('');

	const apiUrl = process.env.REACT_APP_API_URL || '';

	const fetchUsers = async (pageNumber = 1) => {
		setLoading(true);
		setError('');
		try {
			const token = localStorage.getItem('authToken');
			const res = await axios.get(`${apiUrl}/api/users/list?page=${pageNumber}`, {
				headers: { Authorization: `Bearer ${token}` },
			});
			setUsers(res.data.users || []);
			setPage(res.data.page || 1);
			setTotalPages(res.data.totalPages || 1);
		} catch (err) {
			console.error('Błąd podczas ładowania użytkowników:', err);
			setError('Nie udało się pobrać listy użytkowników.');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchUsers(page);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page]);

	// Zmiana roli
	const handleRoleChange = async (userId, newRole) => {
		if (!window.confirm('Czy na pewno chcesz zmienić rolę tego użytkownika?')) return;

		try {
			const token = localStorage.getItem('authToken');
			const res = await axios.patch(
				`${apiUrl}/api/users/changeRole/${userId}`,
				{ role: newRole },
				{ headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
			);

			if (res.status === 200) {
				setUsers(prev => prev.map(u => (u._id === userId ? { ...u, role: newRole } : u)));
				setToast('Rola zmieniona');
			}
		} catch (err) {
			console.error('Błąd podczas zmiany roli:', err);
			setToast('Nie udało się zmienić roli.');
		}
	};

	// Usuwanie użytkownika
	const handleDeleteUser = async (userId, userName) => {
		const confirmation = prompt(
			`Aby usunąć użytkownika "${userName}", wpisz: NA PEWNO`
		);
		if (confirmation !== 'NA PEWNO') return;

		try {
			const token = localStorage.getItem('authToken');
			const res = await axios.delete(`${apiUrl}/api/users/${userId}`, {
				headers: { Authorization: `Bearer ${token}` },
			});

			if (res.status === 200) {
				setUsers(prev => prev.filter(u => u._id !== userId));
				setToast('Użytkownik został usunięty');
			}
		} catch (err) {
			console.error('Błąd podczas usuwania użytkownika:', err);
			setToast('Nie udało się usunąć użytkownika.');
		}
	};

	return (
		<div className="manage-users-wrapper">
			<h2>Zarządzanie użytkownikami</h2>

			{loading && <p>Ładowanie danych...</p>}
			{error && <p className="error-message">{error}</p>}

			{!loading && !error && (
				<>
					<table className="manage-users-table">
						<thead>
							<tr>
								<th>Imię</th>
								<th>Nazwisko</th>
								<th>Email</th>
								<th>Rola</th>
								<th>Akcje</th>
							</tr>
						</thead>
						<tbody>
							{users.length > 0 ? (
								users.map(user => (
									<tr key={user._id}>
										<td>{user.firstName || '-'}</td>
										<td>{user.lastName || '-'}</td>
										<td>{user.email}</td>
										<td>{user.role}</td>
										<td>
											<button
												onClick={() =>
													handleRoleChange(user._id, user.role === 'user' ? 'admin' : 'user')
												}
												className="change-role-button"
											>
												Zmień rolę
											</button>
											<button
												onClick={() => handleDeleteUser(user._id, user.email)}
												className="delete-user-button"
												style={{ marginLeft: '10px' }}
											>
												Usuń
											</button>
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan="5">Brak użytkowników do wyświetlenia.</td>
								</tr>
							)}
						</tbody>
					</table>

					<div className="pagination">
						<button onClick={() => setPage(page - 1)} disabled={page <= 1 || loading}>
							Poprzednia
						</button>
						<span>Strona {page} z {totalPages}</span>
						<button onClick={() => setPage(page + 1)} disabled={page >= totalPages || loading}>
							Następna
						</button>
					</div>
				</>
			)}

			{toast && <Toast message={toast} onClose={() => setToast('')} />}
		</div>
	);
}

export default AdminUserList;
